import { Component, Watch } from 'vue-property-decorator';
import { Button } from 'streamlabs-beaker';
import EditorBase from './EditorBase';
import CanvasContainer from './CanvasContainer.vue';
import Layer from './Layer.vue';
import Settings from './Settings.vue';
import SceneSection from './SceneSection.vue';
import UploadManagerMobile from './modals/UploadManagerMobile.vue';
import CodeEditorModal from '../modals/CodeEditorModal.vue';
import NotificationHelper from '@/helpers/notification';
import StreamContainer from './StreamContainer.vue';
import StreamLabelModal from '@/components/editor/modals/StreamLabelModal.vue';

@Component({
  components: {
    CanvasContainer,
    Layer,
    Settings,
    SceneSection,
    SButton: Button,
    UploadManagerMobile,
    CodeEditorModal,
    StreamContainer,
    StreamLabelModal,
  },
})
export default class Editor extends EditorBase {
  isLandscape: boolean = false;
  showSettings: boolean = true;

  async mounted() {
    if (this.$route.params.projectUuid && this.$route.params.sceneUuid && !this.selectedProject && !this.selectedScene) {
      await this.loadSelectedProject(this.$route.params.projectUuid);
    }

    const activeScene = this.selectedProject.scenes.find(
      (scene) => scene.uuid === this.$route.params.sceneUuid,
    );

    this.selectedScene = activeScene || this.selectedProject.scenes[0];

    if (!activeScene) {
      this.setSceneAsActive(this.selectedScene);
    }

    if (!this.selectedScene) {
      this.$router.push('/projects');
      NotificationHelper.error('Scene not found.');
    }

    this.openCheckoutModalMiniOnUserFlag();

    this.checkOrientation();

    window.addEventListener('orientationchange', this.checkOrientation);
    window.addEventListener('resize', this.checkOrientation);

    this.maybeDisplaySaveButtonTooltip();
  }

  checkOrientation() {
    if (!this.isMobile) return;

    this.isLandscape = screen.orientation ? screen.orientation.type.includes('landscape') : window.innerWidth > window.innerHeight;
  }

  toggleShowSettings() {
    this.showSettings = !this.showSettings;
  }

  @Watch('isLive')
  isLiveEditorHandler() {
    if (this.isLive) this.showSettings = false;
  }
}
